import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { MailModuleActions, MailModuleActionTypes } from '../actions/mail-module.action';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  entities: any;
}

export const initialState: State = {
  isLoaded: false,
  isLoading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: MailModuleActions
): State {
  switch (action.type) {

    case MailModuleActionTypes.GetMailModuleList: {
      return { ...state, isLoaded: false, isLoading: true };
    }

    case MailModuleActionTypes.UpsertMailModuleList: {
      return { ...state, isLoaded: true, isLoading: false, entities: action.payload };
    }

    case MailModuleActionTypes.GetMailModuleListFail: {
      return { ...state, isLoaded: true, isLoading: false, entities: action.payload };
    }

    default: {
      return state;
    }
  }
}

export const getMailModuleListState = (state: State) => state;
